// Generated by purs version 0.15.16
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_RWS_Trans from "../Control.Monad.RWS.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var shiftMapWriterT = function (dictMonoid) {
    var mempty = Data_Monoid.mempty(dictMonoid);
    return {
        shiftMap: function (f) {
            return function (v) {
                return f(function (a) {
                    return new Data_Tuple.Tuple(a, mempty);
                })(v);
            };
        }
    };
};
var shiftMapStateT = function (dictMonad) {
    return {
        shiftMap: function (f) {
            return function (v) {
                return function (s) {
                    return f(function (a) {
                        return new Data_Tuple.Tuple(a, s);
                    })(v(s));
                };
            };
        }
    };
};
var shiftMapReaderT = {
    shiftMap: function (f) {
        return function (v) {
            return function (r) {
                return f(identity)(v(r));
            };
        };
    }
};
var shiftMapRWST = function (dictMonoid) {
    var mempty = Data_Monoid.mempty(dictMonoid);
    return {
        shiftMap: function (f) {
            return function (v) {
                return function (r) {
                    return function (s) {
                        return f(function (a) {
                            return new Control_Monad_RWS_Trans.RWSResult(s, a, mempty);
                        })(v(r)(s));
                    };
                };
            };
        }
    };
};
var shiftMapExceptT = {
    shiftMap: function (f) {
        return function (v) {
            return f(Data_Either.Right.create)(v);
        };
    }
};
var shiftMap = function (dict) {
    return dict.shiftMap;
};
export {
    shiftMap,
    shiftMapExceptT,
    shiftMapRWST,
    shiftMapReaderT,
    shiftMapStateT,
    shiftMapWriterT
};
//# sourceMappingURL=index.js.map
